import getApi from '../../api'
import { TranscriptionAI } from '../../model/TranscriptionAI'

export const startTranscription = () => getApi().get<TranscriptionAI>('/voice_ai/transcribe/start')
